import * as React from 'react'
import {ReactNode} from 'react'
import {APPLY_CATEGORY, ROLE_FOR_GUEST} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {
    getFormattedAddress
} from '../../../applications/contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import {formatDate} from '../../../../../formatters/formatDate'
import styled from 'styled-components'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'
import {
    GuestLoginInfoSessionStorageKey,
    NatGuestLoginInfoSessionStorageHelper
} from '../../../../common/authentication/NatGuestLoginInfoSessionStorageHelper'
import NatGuestOwnershipTransfersDetailConfirmItem from '../../common/NatGuestOwnershipTransfersDetailConfirmItem'
import moment from 'moment/moment'


interface Props {
    applyId?: string
    isApply?: boolean
    ownershipTransferDate: string
    accessExpirationDate?: string
    oldMemberFamilyName: string
    oldMemberFirstName: string
    moveOutDate: string
    phoneNumberAfterMoveOut: string
    zipCodeAfterMoveOut: string
    prefectureAfterMoveOut: string
    address2AfterMoveOut: string
    address3AfterMoveOut: string
    buildingRoomNumberAfterMoveOut: string
    oldMemberMailAddress: string
}

const NatGuestOldMemberConfirm = ({applyId, ...otherProps}: Props) => {
    const {
        ownershipTransferDate, accessExpirationDate, oldMemberFamilyName, oldMemberFirstName, moveOutDate,
        phoneNumberAfterMoveOut, zipCodeAfterMoveOut, prefectureAfterMoveOut,
        address2AfterMoveOut, address3AfterMoveOut, buildingRoomNumberAfterMoveOut, oldMemberMailAddress, isApply
    } = otherProps

    const ownershipTransferDateLabel = formatDate(ownershipTransferDate);
    const accessExpirationDateLabel = accessExpirationDate ? formatDate(accessExpirationDate) : null;
    const moveOutDateLabel = formatDate(moveOutDate);
    const applyCategoryLabel = APPLY_CATEGORY.OWNERSHIP_TRANSFER.label + '（' + ROLE_FOR_GUEST.OLD_MEMBER.label + '様向け）'
    const applicantRoom = NatGuestLoginInfoSessionStorageHelper
            .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatGuestLoginInfoSessionStorageHelper
            .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_RIDGE_NAME) + ' ' +
        convertToRoomNumberForResident(
            NatGuestLoginInfoSessionStorageHelper
                .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    const paymentChangeDeadLineInfo = (): ReactNode => {
        const momentOwnershipTransferDate = moment(ownershipTransferDate)
        const oldMemberDate = momentOwnershipTransferDate.clone().add(1, 'months') // 翌月
        const newMemberDate = momentOwnershipTransferDate.clone().add(2, 'months') // 翌々月

        const items = []
        items.push(`旧組合員：${oldMemberDate.year()}年${oldMemberDate.month() + 1}月分まで支払い`)
        items.push(`新組合員：${newMemberDate.year()}年${newMemberDate.month() + 1}月分から支払い`)

        return <>
            <NatGuestOwnershipTransfersDetailConfirmItem
                title={'管理費等の支払変更期日'}
                items={items}
            />
        </>
    }

    const oldMemberInfo = (): ReactNode => {
        const oldMemberName = oldMemberFamilyName + ' ' + oldMemberFirstName
        const items = []

        items.push(`氏名：${oldMemberName}`)

        return <>
            <NatGuestOwnershipTransfersDetailConfirmItem
                title={'旧組合員情報'}
                items={items}
            />
        </>
    }

    const moveOutInfo = (): ReactNode => {
        const items = []

        items.push(`電話番号：${phoneNumberAfterMoveOut}`)
        items.push(`住所：${getFormattedAddress(
            zipCodeAfterMoveOut,
            prefectureAfterMoveOut,
            address2AfterMoveOut,
            address3AfterMoveOut,
            buildingRoomNumberAfterMoveOut)}`)

        if (oldMemberMailAddress) {
            items.push(`メールアドレス：${oldMemberMailAddress}`)
        }

        return <>
            <NatGuestOwnershipTransfersDetailConfirmItem
                title={'退去後の連絡先'}
                items={items}
            />
        </>
    }

    return (<>
        {applyId && !isApply &&
            <>
                <ViewExpirationDateDiv>閲覧期限：{[accessExpirationDateLabel]}</ViewExpirationDateDiv>
                <NatGuestOwnershipTransfersDetailConfirmItem
                    title={'申請ID'}
                    items={[applyId]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        <NatGuestOwnershipTransfersDetailConfirmItem
            title={'申請区分'}
            items={[applyCategoryLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatGuestOwnershipTransfersDetailConfirmItem
            title={'対象住戸'}
            items={[`${applicantRoom}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatGuestOwnershipTransfersDetailConfirmItem
            title={'組合員変更年月日'}
            items={[`${ownershipTransferDateLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        {paymentChangeDeadLineInfo()}
        <BlockSpacer height={'5px'}/>
        {oldMemberInfo()}
        <BlockSpacer height={'5px'}/>
        <NatGuestOwnershipTransfersDetailConfirmItem
            title={'退去予定日'}
            items={[`${moveOutDateLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        {moveOutInfo()}
    </>)
}

NatGuestOldMemberConfirm.displayName = 'NatGuestOldMemberConfirm'
export default NatGuestOldMemberConfirm

const ViewExpirationDateDiv: StyledDiv = styled.div`
  display: block;
  text-align: right;
  margin-bottom: 5px;
`